export default __webpack_public_path__ + "cd316b032c5d3b519701bf4e87b5c515.png";